import type { GoogleFileType } from '../hooks/use-sheet-access-gate';

/**
 * Single source of truth for per-Google-file-type display strings, shared by
 * the grant-access modal, the documents-rail viewer, and any other surface that
 * needs to name a Google file kind. Keeping this in one place prevents the
 * label/icon/noun wording from drifting between components.
 */
interface GoogleFileTypeConfig {
  /** `docs.google.com/<previewPath>/d/<id>/preview` path segment. */
  previewPath: string;
  /** `material-symbols` icon name for the file type. */
  icon: string;
  /** Product label, e.g. "Google Doc". */
  label: string;
  /** Bare noun for the file, e.g. "document". */
  noun: string;
  /** Plural collection noun, e.g. "documents". */
  collectionNoun: string;
}

const GOOGLE_FILE_TYPE_CONFIG: Record<GoogleFileType, GoogleFileTypeConfig> = {
  document: {
    previewPath: 'document',
    icon: 'material-symbols:description',
    label: 'Google Doc',
    noun: 'document',
    collectionNoun: 'documents',
  },
  spreadsheet: {
    previewPath: 'spreadsheets',
    icon: 'material-symbols:table',
    label: 'Google Sheet',
    noun: 'spreadsheet',
    collectionNoun: 'sheets',
  },
  presentation: {
    previewPath: 'presentation',
    icon: 'material-symbols:slideshow',
    label: 'Google Slides',
    noun: 'presentation',
    collectionNoun: 'slides',
  },
};

export { GOOGLE_FILE_TYPE_CONFIG };
